module.exports = __webpack_public_path__ + "img/list_bg.3cac6a0b.png";